import { strRemoveSpaces } from "../inc/helpers";

const labels = window["appData"]["data"]["res"]["labels"];

export default class ContactForm {
    constructor({form}) {
        this._form = form;
        if (!this._form) return;

        this._type = this._form.querySelector(".js-user-type");
        this._type0 = this._type.options[0].value;
        this._typeCurr = this._type0;
        this._typeChanged = false;
        this._subject = this._form.querySelector(".js-user-subject");
        this._company = this._form.querySelector(".js-user-company");
        this._cv = this._form.querySelector(".js-user-cv");
        this._btnSubmit = this._form.querySelector(".wpcf7-submit");
        this._inputsRequired = [
            ...Array.from(this._form.querySelectorAll(".wpcf7-form-control[aria-required='true']"))
                .filter(input => input !== this._type),
            this._company,
            this._cv,
            this._form.querySelector(".wpcf7-acceptance [name='privacy-policy']")
        ];
        this._errors = [];

        this._replaceBtnSubmit();
        this._createInputCvVisible();
        this._onTypeChange();
        this._onInputsChange();

        this._inputsRequired.forEach(input => {
            input.addEventListener("change", this._onInputsChange.bind(this));
            input.addEventListener("input", this._onInputsChange.bind(this));
        });
        this._type?.addEventListener("click", this._onTypeClick.bind(this));
        this._type?.addEventListener("keydown", this._onTypeClick.bind(this));
        this._type?.addEventListener("change", this._onTypeChange.bind(this));
        this._type?.addEventListener("blur", () => this._type.classList.remove("is-open"));
        this._cv?.addEventListener("change", this._onCvChange.bind(this));
        this._btnSubmit.addEventListener("click", (e) => {
            if (this._errors.length > 0) 
                e.preventDefault();             
        });
        this._form.addEventListener("wpcf7mailsent", (e) => {
            const lblVisible = this._form.querySelector(".upload-file-lbl"); 
            lblVisible.textContent = labels.lblNoFileSelected;
        });
    }

    _replaceBtnSubmit() {
        const container = this._btnSubmit.parentNode;
        const btn = document.createElement("button");
        btn.classList.add("btn", "btn-primary", "btn-submit");
        btn.setAttribute("type", "submit");
        btn.textContent = this._btnSubmit.value;
        container.replaceChild(btn, this._btnSubmit);
        this._btnSubmit = btn;
    }

    _createInputCvVisible() {
        const container = this._cv.parentNode;
        const inputVisible = document.createElement("div");
        const btnVisible = document.createElement("button");
        const lblVisible = document.createElement("span");

        inputVisible.classList.add("input-file-visible");
        inputVisible.setAttribute("inert", "");
        btnVisible.classList.add("btn", "btn-primary", "btn-upload-file");
        btnVisible.setAttribute("inert", "");
        btnVisible.setAttribute("type", "button");
        btnVisible.textContent = labels.lblFileUpload;
        btnVisible.setAttribute("aria-label", labels.lblFileUpload);
        lblVisible.classList.add("upload-file-lbl");
        lblVisible.textContent = labels.lblNoFileSelected;

        inputVisible.append(btnVisible, lblVisible);
        container.appendChild(inputVisible);
    }

    _onCvChange() {
        const container = this._cv.parentNode;
        const lblVisible = container.querySelector(".upload-file-lbl"); 
        const file = this._cv.files[0];       
        
        lblVisible.textContent = 
            file 
                ? file.name
                : labels.lblNoFileSelected;
    }

    _onTypeClick(e) {
        if (e.type === "keydown") {
            if (e.key === " " && !this._type.classList.contains("is-open")) 
                this._type.classList.add("is-open");
        
            return;

        } else if (e.type === "click") {
            if (this._typeChanged) {
                this._type.classList.remove("is-open");
                this._typeChanged = false;
            
            } else if (!this._type.classList.contains("is-open")) {
                this._type.classList.add("is-open");

            }  else {
                this._type.classList.remove("is-open");
            }
        }
    }

    _onTypeChange() {        
        const value = this._type.value;
        const lblFileVisible = this._form.querySelector(".upload-file-lbl");
                
        this._typeChanged = this._typeCurr !== value;
        this._typeCurr = value;        
        
        if (value === this._type0) {            
            this._cv.value = "";
            lblFileVisible.textContent = labels.lblNoFileSelected;
            this._company?.classList.remove("is-hidden");
            if (!this._cv?.classList.contains("is-hidden"))
                this._cv?.classList.add("is-hidden");         
            this._subject.placeholder = labels.phSubject0;

            return;
        }

        this._company.value = "";
        if (!this._company?.classList.contains("is-hidden"))
            this._company?.classList.add("is-hidden");
        this._cv?.classList.remove("is-hidden");
        this._subject.placeholder = labels.phSubject1;
    }

    _onInputsChange() {
        this._errors = [];        

        this._inputsRequired.forEach(input => {
            if (input.type === "checkbox") {
                if (!input.checked) 
                    this._errors.push(input.name);

            } else if (input.type === "file") {
                if (!input.value?.length > 0)
                    this._errors.push(input.name);

            } else if (!strRemoveSpaces(input.value)?.length > 0) {
                this._errors.push(input.name);
            }
        });    
        
        this._errors = this._errors.filter(err => err !== "user-cv" && err !== "user-company");

        if (this._typeCurr === this._type0) {            
            if (!strRemoveSpaces(this._company.value)?.length > 0)
                this._errors.push(this._company.name);

        } else {
            if (!this._cv.value.length > 0)
                this._errors.push(this._cv.name);
        } 

        this._btnSubmit.disabled = this._errors.length > 0;
    }
}